const styles = theme => ({
  about: {
    lineHeight: "30px", 
    "& h1": {
      color: theme.colors.primary,
      textAlign: "center",
    },
    "& p": {
      textAlign: "justify"
    },  
  },

  container: {
    display: "flex",
    flexWrap: "wrap",
    margin: -15,
    position: "relative"
  },
  loading: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    overflow: "hidden",
    zIndex: 10,

    "& svg": {
      color: theme.colors.primary
    }
  }
});
export default styles;
